import { store } from "../../app/store";
import { setWorkbookData } from "../reduxworkbook/WorkbookSlice";
import { Outlet, useSearchParams } from "react-router-dom";
import { useGetWorkbookQuery } from "../reduxworkbook/dataApiSlice";
import LoadingIndicator from "../../components/BasicComponents/LoadingIndicator";
import usePreviousLocation from "../../hooks/usePreviousLocation";
import { useEffect, useState } from "react";

const Prefetch = () => {
  const [searchParams] = useSearchParams();
  const previousLocation = usePreviousLocation();

  const savedWorkBookId =
    searchParams.get("workbookid") || sessionStorage.getItem("workBookId");

  const [shouldFetch, setShouldFetch] = useState(false);

  // Set shouldFetch based on previous location
  useEffect(() => {
    if (previousLocation) {
      if (previousLocation.pathname === "/datasource") {
        console.log("Comes from datasource page");
        setShouldFetch(false);
      } else {
        console.log("Comes from df url");
        setShouldFetch(true);
      }
    } else {
      // default to true if no previousLocation — can customize as needed
      setShouldFetch(true);
    }
  }, [previousLocation]);

  // RTK Query
  const { data, error, isLoading } = useGetWorkbookQuery(savedWorkBookId, {
    skip: !savedWorkBookId || !shouldFetch,
    refetchOnMountOrArgChange: true,
  });

  // Dispatch data when fetched
  useEffect(() => {
    if (data) {
      console.log("Prefetch successful");
      store.dispatch(setWorkbookData(data));
    }
  }, [data]);

  // Show loading spinner
  if (isLoading) {
    console.log("loading...");    
    return <LoadingIndicator />;
  }

  // Show error message
  if (error) {
    console.log("error"); 
    console.error("Error prefetching data:", error);
    return (
      <div>
        Error occurred while fetching data, please close this tab and open a new
        tab
      </div>
    );
  }
  console.log("outlet returned");
  
  // ✅ Handle case when API is skipped (but route still needs to render children)
  return <Outlet />;
};

export default Prefetch;
